/** @format */

import joseEmanuel from '../images/result/joseEmanuel.jpg';
import joseEmanuelWebp from '../images/result/joseEmanuel.webp';

import nicolasGonzalez from '../images/result/nicolasGonzalez.jpg';
import nicolasGonzalezWebp from '../images/result/nicolasGonzalez.webp';

import juanDadomo from '../images/result/juanDadomo.jpg';
import juanDadomoWebp from '../images/result/juanDadomo.webp';

import juanManuelMontoya from '../images/result/juanManuelMontoya.jpg';
import juanManuelMontoyaWebp from '../images/result/juanManuelMontoya.webp';

import miguelPacheco from '../images/result/miguelPacheco.jpg';
import miguelPachecoWebp from '../images/result/miguelPacheco.webp';

import miguelPacheco2 from '../images/result/miguelPacheco2.jpg';
import miguelPacheco2Webp from '../images/result/miguelPacheco2.webp';

import alessioRossi from '../images/result/alessioRossi.jpg';
import alessioRossiWebp from '../images/result/alessioRossi.webp';

import deissyCastillo from '../images/result/DeissyCastillo.jpg';
import deissyCastilloWebp from '../images/result/DeissyCastillo.webp';

import matiasMiloro from '../images/result/matiasMiloro.jpg';
import matiasMiloroWebp from '../images/result/matiasMiloro.webp';

import carlosAcevedo from '../images/result/carlosAcevedo.jpg';
import carlosAcevedoWebp from '../images/result/carlosAcevedo.webp';

import luisGutierrez from '../images/result/luisGutierrez.jpg';
import luisGutierrezWebp from '../images/result/luisGutierrez.webp';

import danielaCortes from '../images/result/danielaCortes.jpg';
import danielaCortesWebp from '../images/result/danielaCortes.webp';

import gerardMartinez from '../images/result/gerardMartinez.jpg';
import gerardMartinezWebp from '../images/result/gerardMartinez.webp';

import emiliaCervantes from '../images/result/emiliaCervantes.jpg';
import emiliaCervantesWebp from '../images/result/emiliaCervantes.webp';

import rodrigoNeira from '../images/result/rodrigoNeira.jpg';
import rodrigoNeiraWebp from '../images/result/rodrigoNeira.webp';

const results = [
  {
    id: 0,
    technology: 'Blender',
    project: 'Domina Blender',
    student: 'Jose Emanuel',
    country: 'Chile',
    image: joseEmanuel,
    imageWebp: joseEmanuelWebp,
    video: 'https://www.youtube.com/watch?v=d93KEZs8Ewg',
  },
  {
    id: 1,
    technology: 'ZBrush',
    project: 'Hardsurface Girl',
    student: 'Nicolas Gonzalez',
    country: 'Chile',
    image: nicolasGonzalez,
    imageWebp: nicolasGonzalezWebp,
    video: 'https://www.youtube.com/watch?v=L_49m_pSwE8',
  },
  {
    id: 2,
    technology: 'Substance',
    project: 'Lost Toys',
    student: 'Emilia Cervantes',
    country: 'Ecuador',
    image: emiliaCervantes,
    imageWebp: emiliaCervantesWebp,
    video: 'https://www.youtube.com/watch?v=AztAqbfPGpI',
  },
  {
    id: 3,
    technology: 'Blender',
    project: 'Tool Box',
    student: 'Rodrigo Neira',
    country: 'Argentina',
    image: rodrigoNeira,
    imageWebp: rodrigoNeiraWebp,
    video: 'https://vimeo.com/359689436',
  },
  {
    id: 4,
    technology: 'ZBrush',
    project: 'Cyberpunk',
    student: 'Juan Dadomo',
    country: 'Uruguay',
    image: juanDadomo,
    imageWebp: juanDadomoWebp,
    video: 'https://www.youtube.com/watch?v=ZfEeKuHlnSA',
  },
  {
    id: 5,
    technology: 'Blender',
    project: 'Pilot Gorilla',
    student: 'Jose Manuel Montoya',
    country: 'Colombia',
    image: juanManuelMontoya,
    imageWebp: juanManuelMontoyaWebp,
    video: 'https://www.youtube.com/watch?v=flEz66qXrcs',
  },
  {
    id: 6,
    technology: 'Blender',
    project: 'Dark Gunman',
    student: 'Miguel Pacheco',
    country: 'United States',
    image: miguelPacheco,
    imageWebp: miguelPachecoWebp,
    video: 'https://www.youtube.com/shorts/o1aZvwQ_fWM',
  },
  {
    id: 7,
    technology: 'Blender',
    project: 'Fary House',
    student: 'Miguel Pacheco',
    country: 'United States',
    image: miguelPacheco2,
    imageWebp: miguelPacheco2Webp,
    video: 'https://www.youtube.com/watch?v=Qv9FGcObJgs',
  },
  {
    id: 8,
    technology: 'Blender',
    project: 'Pandarosso',
    student: 'Alessio Rossi',
    country: 'Italia',
    image: alessioRossi,
    imageWebp: alessioRossiWebp,
    video: 'https://www.youtube.com/watch?v=47VjKsfjmtk',
  },
  {
    id: 9,
    technology: 'Blender',
    project: 'Batmobile Lego',
    student: 'Deissy Castillo',
    country: 'Colombia',
    image: deissyCastillo,
    imageWebp: deissyCastilloWebp,
    video: 'https://www.youtube.com/watch?v=Eivej6HMYG8',
  },
  {
    id: 10,
    technology: 'ZBrush',
    project: 'Cyberpunk',
    student: 'Matías Miloro',
    country: 'Argentina',
    image: matiasMiloro,
    imageWebp: matiasMiloroWebp,
    video: 'https://www.youtube.com/watch?v=oGpWs_-fFpc',
  },
  {
    id: 11,
    technology: 'Blender',
    project: 'Night Elf',
    student: 'Carlos Acevedo',
    country: 'Colombia',
    image: carlosAcevedo,
    imageWebp: carlosAcevedoWebp,
    video: 'https://www.youtube.com/watch?v=d0MyVfez1tw',
  },
  {
    id: 12,
    technology: 'Blender',
    project: 'Dark Gunman',
    student: 'Luis Gutierrez',
    country: 'United States',
    image: luisGutierrez,
    imageWebp: luisGutierrezWebp,
    video: 'https://www.youtube.com/watch?v=Q3e1xDWkRhA',
  },
  {
    id: 13,
    technology: 'Blender',
    project: 'Little Devil',
    student: 'Daniela Cortés',
    country: 'Colombia',
    image: danielaCortes,
    imageWebp: danielaCortesWebp,
    video: 'https://www.youtube.com/watch?v=xNn_aBoYgU0',
  },
  {
    id: 14,
    technology: 'ZBrush',
    project: 'Hardsurface Girl',
    student: 'Gerard Martínez',
    country: 'España',
    image: gerardMartinez,
    imageWebp: gerardMartinezWebp,
    video: 'https://www.youtube.com/watch?v=VEJD2GgiJbo',
  },
  // {
  //     id: 15,
  //     technology: "ZBrush",
  //     project: "Music Robot",
  //     student: "Gustavo Mejía",
  //     country: "Colombia",
  //     image: gustavoMejia,
  //     imageWebp: gustavoMejiaWebp,
  //     avatar: gustaAvatar,
  //     video: "https://youtu.be/WmH6XbY8XEE",
  // },
  // {
  //     id: 16,
  //     technology: "Blender",
  //     project: "Space Bear",
  //     student: "Jose Emanuel",
  //     country: "México",
  //     image: joseEmanuel,
  //     imageWebp: joseEmanuelWebp,
  //     avatar: joseAvatar,
  //     video: "https://youtu.be/d93KEZs8Ewg",
  // },
  // {
  //     id: 17,
  //     technology: "ZBrush",
  //     project: "Salamander",
  //     student: "Katherine Berrocal",
  //     country: "Perú",
  //     image: katherineBerrocal,
  //     imageWebp: katherineBerrocalWebp,
  //     avatar: katherineAvatar,
  //     video: "https://youtu.be/1flkB1_Ell8",
  // },
  // {
  //     id: 18,
  //     technology: "ZBrush",
  //     project: "Music Robot",
  //     student: "Gustavo Mejía",
  //     country: "Colombia",
  //     image: gustavoMejia,
  //     imageWebp: gustavoMejiaWebp,
  //     avatar: gustaAvatar,
  //     video: "https://youtu.be/WmH6XbY8XEE",
  // },
  // {
  //     id: 19,
  //     technology: "Blender",
  //     project: "Space Bear",
  //     student: "Jose Emanuel",
  //     country: "México",
  //     image: joseEmanuel,
  //     imageWebp: joseEmanuelWebp,
  //     avatar: joseAvatar,
  //     video: "https://youtu.be/d93KEZs8Ewg",
  // },
  // {
  //     id: 20,
  //     technology: "ZBrush",
  //     project: "Salamander",
  //     student: "Katherine Berrocal",
  //     country: "Perú",
  //     image: katherineBerrocal,
  //     imageWebp: katherineBerrocalWebp,
  //     avatar: katherineAvatar,
  //     video: "https://youtu.be/1flkB1_Ell8",
  // },
  // {
  //     id: 21,
  //     technology: "ZBrush",
  //     project: "Music Robot",
  //     student: "Gustavo Mejía",
  //     country: "Colombia",
  //     image: gustavoMejia,
  //     imageWebp: gustavoMejiaWebp,
  //     avatar: gustaAvatar,
  //     video: "https://youtu.be/WmH6XbY8XEE",
  // },
  // {
  //     id: 22,
  //     technology: "Blender",
  //     project: "Space Bear",
  //     student: "Jose Emanuel",
  //     country: "México",
  //     image: joseEmanuel,
  //     imageWebp: joseEmanuelWebp,
  //     avatar: joseAvatar,
  //     video: "https://youtu.be/d93KEZs8Ewg",
  // },
  // {
  //     id: 23,
  //     technology: "ZBrush",
  //     project: "Salamander",
  //     student: "Katherine Berrocal",
  //     country: "Perú",
  //     image: katherineBerrocal,
  //     imageWebp: katherineBerrocalWebp,
  //     avatar: katherineAvatar,
  //     video: "https://youtu.be/1flkB1_Ell8",
  // },
];

export default results;
